import React, { Fragment } from "react"
import shop from "shop/shop"
import { default as SlickSlider } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "style/CMSSlider.scss"
import { Container, Image, Button } from "semantic-ui-react"
import settingStore from "stores/settingStore"
import { observer }                                              from "mobx-react"
import Slider from "components/Slider/Slider"
import Responsive from "react-responsive"
// import "react-responsive-carousel/lib/styles/carousel.min.css"

@observer
export default class SliderHomePage extends React.Component {


  render() {
    const props = this.props
    console.log("SliderHomePage", props)
    return (
            <Fragment>
            <Responsive minWidth={768}>
            {
                <Slider
                autoplaySpeed={5000}
                autoplay={false}
                slidesToShow={1}
                slidesToScroll={1}
                centerMode={false}
                centerPadding="0px"
                dots={true}
                >{/*settingStore.get("orderMode") == "laboratory" && */}
                <div style={{ position: "relative" }}> {/*src="/image/583dca1af9766f36303993e91ae728db (1).jfif" */}
                    <Image
                    src="/image/slider_1.jpg"
                    alt="Slide Image"
                    style={{
                        width: "100%",
                        height: "100vh",
                        objectFit: "cover",
                        objectPosition: "0% 40%",
                        filter: "brightness(70%)"
                    }}
                    />
                    
                    <div 
                    style={{
                    position: "absolute",
                    top: "65%",
                    left: "28%",
                    transform: "translate(-40%, -50%)",
                    color: "white",
                    textAlign: "center",
                    }}
                    >
                        <div className="">
                    <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                    <p className="fw6 f1  pt2 tl" >
                    {translate("Ihr zuverlässiger Partner für Medizinalbedarf")}<br/>{translate("Jetzt online bestellen")}
                    </p>
                    <p className="fw4 f4 tl pb3">{translate("Entdecken Sie im Herenz Online-Shop hochwertige")}<br />{translate("Produkte für Labor, Medizin und Krankenhausbedarf")}</p>
                    <div className="tl">
                        <table>
                        <tbody>
                            <tr>
                            <td className="pr2">
                            <Button 
                    style={{
                        borderRadius: "35px", 
                        height: "60px", 
                        width: "250px", 
                        backgroundColor: "white", 
                        color: "#369678",
                        transition: "all 0.3s ease",
                        padding: "10px 20px 10px 20px",
                    }} 
                    className=" ml3 pl3 mr2"
                    onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => {this.props.props.history.push("/collection/40/50/51/");}}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                href={`tel:+49407392040`}>{translate("Telefonberatung")}
                </Button> */}
                        </td>
                    </tr>
                    </tbody>    
                </table>
                </div>
    
                </div>
                </div>
                </div>
                <div style={{ position: "relative" }}> {/*src="/image/0a9db1922b9ea4b1ee47c088bb702c73.jfif" */}
                <Image
                src="/image/slider_2.jpg"
                alt="Slide Image"
                style={{
                        width: "100%",
                        height: "100vh",
                        objectFit: "cover",
                        objectPosition: "center",
                        filter: "brightness(70%)"
                    }}
                />
                <div
                style={{
                position: "absolute",
                top: "65%",
                left: "28%",
                transform: "translate(-40%, -50%)",
                color: "white",
                textAlign: "center",
                }}
                >
                <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                <p className="fw6 f1  pt2 tl" >
                {translate("Gynobrush® Abstrichbürsten")}
                </p>
                <p className="fw4 f4 tl pb3">{translate("Mit Gynobrush® Abstrichbürsten lassen sich bei gynäkologischen")} <br/>{translate("Untersuchungen zuverlässig Proben aus dem Endozervicalbereich entnehmen.")}</p>
                <div className="tl">
                <table>
                    <tbody>
                    <tr>
                        <td className="pr2">
                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "250px", 
                backgroundColor: "white", 
                color: "#369678",
                transition: "all 0.3s ease",
                padding: "10px 20px 10px 20px",
                }} 
                className=" ml3 pl3 mr2"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => this.props.props.history.push("/collection/40/59/187/")}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                >
                {translate("Telefonberatung")}
                </Button> */}
                        </td>
                    </tr>
                    </tbody>    
                </table>
    
    
                </div>
                </div>
                </div>
                <div style={{ position: "relative" }}> {/*src="/image/6790114c0d24876e89504b3b71920a84.jfif" */}
                <Image
                src="/image/slider_3.jpg"
                alt="Slide Image"
                style={{
                        width: "100%",
                        height: "100vh",
                        objectFit: "cover",
                        objectPosition: "center",
                        filter: "brightness(70%)"
                    }}
                />
                <div
                style={{
                position: "absolute",
                top: "65%",
                left: "28%",
                transform: "translate(-40%, -50%)",
                color: "white",
                textAlign: "center",
                }}
                >
                <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                <p className="fw6 f1  pt2 tl" >
                {translate("Skalpellklingen")}
                </p>
                <p className="fw4 f4 tl pb3">{translate("Skalpellklingen werden für Mehrweg-Skalpelle verwendet. Nach Gebrauch")} <br/>{translate("wird die Klinge entsorgt und das Skalpell gründlich gereinigt, sodass es ")}<br/>{translate("mit einer neuen Klinge versehen wieder zum Einsatz kommt.")}</p>
                <div className="tl">
                <table>
                    <tbody>
                    <tr>
                        <td className="pr2">
                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "250px", 
                backgroundColor: "white", 
                color: "#369678",
                transition: "all 0.3s ease",
                padding: "10px 20px 10px 20px",
                }} 
                className=" ml3 pl3 mr2"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => this.props.props.history.push("/collection/49/149/150/")}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                    {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                href={`tel:+49407392040`}>{translate("Telefonberatung")}
                </Button> */}
                    </td>
                  </tr>
                  </tbody>    
                </table>
    
    
                </div>
                </div>
                </div>

                </Slider>}
            </Responsive>
            <Responsive maxWidth={767}>
            {<Slider
                autoplaySpeed={5000}
                autoplay={false}
                slidesToShow={1}
                slidesToScroll={1}
                centerMode={false}
                centerPadding="0px"
                dots={true}
                >
                <div style={{ position: "relative" }}> {/*src="/image/583dca1af9766f36303993e91ae728db (1).jfif" */}
                    <Image
                    src="/image/slider_1.jpg"
                    alt="Slide Image"
                    style={{ width: "100%", height: "100%", maxHeight: "20%", filter: "brightness(70%)" }}
                    />
                    
                    <div 
                    style={{
                    position: "absolute",
                top: "60%",
                left: "40%",
                    transform: "translate(-40%, -50%)",
                    color: "white",
                    textAlign: "center",
                    }}
                    >
                        <div className="">
                        <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                    <p className="fw6 f5  pt2 tl" >
                    {translate("Ihr zuverlässiger Partner für Medizinalbedarf")}<br/>{translate("Jetzt online bestellen")}
                    </p>
                    <div className="tl pt3">
                        <table>
                        <tbody>
                            <tr>
                            <td className="pr2">
                            <Button 
                    style={{
                        borderRadius: "35px", 
                        height: "60px", 
                        width: "200px", 
                        backgroundColor: "white", 
                        color: "#369678",
                        transition: "all 0.3s ease",
                    }} 
                    className=" ml3 pl3 mr2"
                    onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => {this.props.props.history.push("/collection/40/50/51/");}}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                    {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                >
                {translate("Telefonberatung")}
                </Button> */}
                        </td>
                    </tr>
                    </tbody>    
                </table>
                </div>
    
                </div>
                </div>
                </div>
                <div style={{ position: "relative" }}> {/*src="/image/0a9db1922b9ea4b1ee47c088bb702c73.jfif" */}
                <Image
                src="/image/slider_2.jpg"
                alt="Slide Image"
                style={{ width: "100%", height: "100%", maxHeight: "100vh", filter: "brightness(70%)" }}
                />
                <div
                style={{
                position: "absolute",
                top: "60%",
                left: "30%",
                transform: "translate(-40%, -50%)",
                color: "white",
                textAlign: "center",
                }}
                >
                <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                <p className="fw6 f5  pt2 tl" >
                {translate("Gynobrush® Abstrichbürsten")}
                </p>
                <div className="tl pt3">
                <table>
                    <tbody>
                    <tr>
                        <td className="pr2">
                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "white", 
                color: "#369678",
                transition: "all 0.3s ease",
                }} 
                className=" ml3 pl3 mr2"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => this.props.props.history.push("/collection/40/59/187/")}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                    {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                >
                {translate("Telefonberatung")}
                </Button> */}
                        </td>
                    </tr>
                    </tbody>    
                </table>
    
    
                </div>
                </div>
                </div>
                <div style={{ position: "relative" }}> {/*src="/image/6790114c0d24876e89504b3b71920a84.jfif" */}
                <Image
                src="/image/slider_3.jpg"
                alt="Slide Image"
                style={{ width: "100%", height: "100%", maxHeight: "100vh", filter: "brightness(70%)" }}
                />
                <div
                style={{
                position: "absolute",
                top: "60%",
                left: "30%",
                transform: "translate(-40%, -50%)",
                color: "white",
                textAlign: "center",
                }}
                >
                <p style={{ borderTop: "2px solid white", width: "50%", marginLeft: "0" }}></p>
                <p className="fw6 f5  pt2 tl" >
                {translate("Skalpellklingen")}
                </p>
                <div className="tl pt3">
                <table>
                    <tbody>
                    <tr>
                        <td className="pr2">
                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "white", 
                color: "#369678",
                transition: "all 0.3s ease",
                }} 
                className=" ml3 pl3 mr2"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.color = "#369678";
                }}
                onClick={() => this.props.props.history.push("/collection/49/149/150/")}>
                {translate("Kategorie anzeigen")}
                </Button>
                        </td>
                        <td>
                    {/*                        <Button 
                style={{
                borderRadius: "35px", 
                height: "60px", 
                width: "200px", 
                backgroundColor: "transparent", 
                border: "2px solid white", 
                color: "white",
                transition: "all 0.3s ease",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                }} 
                className="fw5 ml3 pl3"
                onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#369678";
                e.target.style.color = "white";
                e.target.style.border = "2px solid #369678";
                }}
                onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
                e.target.style.border = "2px solid white";
                }}
                >
                {translate("Telefonberatung")}
                </Button> */}
                    </td>
                  </tr>
                  </tbody>    
                </table>    
                </div>
                </div>
                </div>
                </Slider>}
            </Responsive>
                
        </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Slider/SilderHomePage.js